import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    display: 'inline-block',
    width: '100%',
    fontSize: 20,
    textAlign: 'center',
  },
})

const Stat = (props) => {
  const { root } = useStyles()
  return (
    <Box
      {...props}
      className={root}
    />
  )
}
export default Stat
